import { Modal } from '@arnold/common';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface IProps {
  show: boolean;
  hideModal: () => void;
  name: string;
  onSubmit: () => void;
}
export const SendAgainModal: FC<IProps> = ({ show, hideModal, name, onSubmit }) => {
  const { t } = useTranslation('sendAgainModal');

  if (show) {
    return (
      <Modal
        show={show}
        onHide={hideModal}
        onSubmit={onSubmit}
        title={t('sendAgainTitle')}
        text={<Trans i18nKey="sendAgainModal:description" values={{ name }} components={[<strong />]} />}
        buttons={{
          cancel: { title: t('cancel') },
          submit: { title: t('submit') },
        }}
      />
    );
  }
  return null;
};
